import { render, staticRenderFns } from "./FullWidthCellTransaction.vue?vue&type=template&id=188d3803&scoped=true"
import script from "./FullWidthCellTransaction.vue?vue&type=script&lang=js"
export * from "./FullWidthCellTransaction.vue?vue&type=script&lang=js"
import style0 from "./FullWidthCellTransaction.vue?vue&type=style&index=0&id=188d3803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d3803",
  null
  
)

export default component.exports